import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import ContactForm from "../../ContactForm";

export default function TitleForm() {
  const navigate = useNavigate();

  const [formDataState, setFormDataState] = useState({
    name: "",
    email: "",
    phone: "",
    findUs: "",
    message: "",
  });

  const [status, setStatus] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormDataState((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const sendEmail = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("name", formDataState.name);
    formData.append("email", formDataState.email);
    formData.append("phone", formDataState.phone);
    formData.append("findUs", formDataState.findUs);
    formData.append("message", formDataState.message);

    try {
      const response = await axios.post(
        "https://entdelhi.com/mailer/mailer.php",
        formData
      );

      if (response.data.success) {
        setStatus("Message sent successfully!");
        setFormDataState({
          name: "",
          email: "",
          phone: "",
          findUs: "",
          message: "",
        });
        navigate("/thank-you");
      } else {
        setStatus("Failed to send message.");
        console.error(response.data.error);
      }
    } catch (error) {
      setStatus("Something went wrong!");
      console.error("Axios error:", error);
    }
  };

  return (
    <div>
      {/* ✅ Inline CSS to add circle bullets */}
      <style>{`
        ul {
          list-style-type: disc;
          padding-left: 1.5rem;
        }
        ul li {
          margin-bottom: 0.5rem;
        }
      `}</style>

      <section className="about-us">
        <div className="container">
          <div className="row">
            <div className="col-xl-8 px-xl-8 mt-4 mt-xl-0">
              <div className="pq-section pq-style-1 text-left">
                <span className="pq-section-sub-title">
                  Medfirst ENT Centre
                </span>
                <h1 className="pq-section-title">Advanced Vertigo Clinic in Delhi, India</h1>
                <p className="pq-section-description">
                  A Vertigo Clinic is a specialized medical center focused on
                  diagnosing and treating conditions that cause dizziness,
                  imbalance, and spinning sensations. These symptoms are often
                  related to inner <a href="https://entdelhi.com/ear-clinic-delhi/">Ear</a> problems or neurological disorders that
                  affect the body’s balance system. At our Vertigo Clinic,
                  patients receive comprehensive care from ENT (Ear, Nose &
                  Throat) specialists and trained professionals who understand
                  the complex causes of vertigo. The clinic is equipped with
                  advanced diagnostic tools and therapies to accurately identify
                  the source of dizziness and provide effective treatment.
                  Vertigo is the sensation that you or your surroundings are
                  spinning or moving, even when you're standing still. It can
                  be triggered by issues in the inner ear (vestibular system),
                  brain, or sensory nerve pathways.
                </p>
                <br />
                <ul>
                  <li>Common causes include:</li>
                  <li>Benign Paroxysmal Positional Vertigo (BPPV)</li>
                  <li>Meniere’s Disease</li>
                  <li>Vestibular Neuritis or Labyrinthitis</li>
                  <li>Migraine-Associated Vertigo</li>
                  <li>Ear Infections and Trauma</li>
                </ul>
              </div>
            </div>

            <div className="col-xl-4 pe-xl-4">
                    <ContactForm />
              {/*<div className="pq-bg-white pq-form-bg-white p-4">
                <div className="pq-applyform-whitebg p-4">
                  <form onSubmit={sendEmail}>
                    <div className="row">
                      <div className="col-md-12">
                        <input
                          type="text"
                          name="name"
                          placeholder="Name"
                          value={formDataState.name}
                          onChange={handleChange}
                          required
                        />
                      </div>
                      <div className="col-md-12">
                        <input
                          type="email"
                          name="email"
                          placeholder="Email"
                          value={formDataState.email}
                          onChange={handleChange}
                          required
                        />
                      </div>
                      <div className="col-md-12">
                        <input
                          type="tel"
                          name="phone"
                          placeholder="Phone Number"
                          value={formDataState.phone}
                          onChange={handleChange}
                          required
                          onInput={(e) => {
                            e.target.value = e.target.value.replace(/\D/g, "");
                          }}
                        />
                      </div>
                      <div className="col-md-12">
                        <input
                          type="text"
                          name="message"
                          Placeholder="Concern"
                          value={formDataState.message}
                          onChange={handleChange}
                          required
                        />
                      </div>
                      <div className="col-md-12">
                        <select
                          name="findUs"
                          value={formDataState.findUs}
                          onChange={handleChange}
                          required
                        >
                          <option value="" disabled>
                            How did you find us?
                          </option>
                          <option value="youtube">YouTube</option>
                          <option value="instagram-facebook">
                            Instagram/Facebook
                          </option>
                          <option value="google">Google</option>
                          <option value="reference">Reference</option>
                        </select>
                      </div>
                      <div className="col-md-12 pt-2">
                        <button type="submit">Send Message</button>
                      </div>
                    </div>
                  </form>
                  <p>{status}</p>
                </div>
              </div>*/}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
